module.exports = __webpack_public_path__ + "img/handwrite-seal.a48be4c9.svg";